import React, { useState, useMemo } from 'react';
import projects from '../data/projects';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'cybersecurity', label: 'Cybersec' },
  { key: 'low-level', label: 'Low-level' },
  { key: 'web', label: 'Web' },
  { key: 'dataia', label: 'Data / IA' },
  { key: 'gamedev', label: 'Game Dev' },
  { key: 'desktop', label: 'Desktop' },
];

const TYPE_LABEL = {
  cybersecurity: 'Cybersec',
  'low-level': 'Low-level',
  web: 'Web',
  dataia: 'Data / IA',
  gamedev: 'Gamedev',
  desktop: 'Desktop',
};

const BENTO_SIZES = ['size-big', 'size-side', 'size-reg', 'size-reg', 'size-reg'];

export default function Projects() {
  const [filter, setFilter] = useState('all');
  const list = useMemo(
    () => projects.filter(p => filter === 'all' || p.types.includes(filter)),
    [filter]
  );

  return (
    <section id="work">
      <div className="container-x">
        <header className="section-head">
          <h2 data-reveal="">Things I've shipped, broken, and rebuilt — <em>on purpose.</em></h2>
        </header>

        <div className="filters" data-reveal="">
          <button className={`filter ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>All</button>
          <span className="sep" />
          {FILTERS.filter(f => f.key !== 'all').map(f => (
            <button key={f.key} className={`filter ${filter === f.key ? 'active' : ''}`} onClick={() => setFilter(f.key)}>{f.label}</button>
          ))}
        </div>

        <div className="work-grid" data-reveal="">
          {list.map((p, i) => {
            const size = BENTO_SIZES[i % BENTO_SIZES.length];
            const tagCount = size === 'size-big' ? 6 : (size === 'size-side' ? 4 : 3);
            return (
              <a key={p.title} className={`work-tile ${size}`}
                 href={p.link} target="_blank" rel="noopener noreferrer">
                <div className="media">
                  <img src={p.image} alt={p.title} loading="lazy"
                       style={p.imageZoom ? { '--img-zoom': p.imageZoom } : undefined} />
                </div>
                <div className="body">
                  <div className="topline">
                    <span>{p.types.map(t => TYPE_LABEL[t] || t).join(' · ')}</span>
                    <div className="topline-right">
                      {p.badges && p.badges.map(b => <span key={b} className="badge">{b}</span>)}
                      <span className="y">{p.year}</span>
                    </div>
                  </div>
                  <h3>{p.title}</h3>
                  <p className="desc">{p.desc}</p>
                  <div className="foot">
                    <div className="tags">{p.tags.slice(0, tagCount).map(t => <span key={t} className="tag">{t}</span>)}</div>
                    <svg className="open-arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4">
                      <path d="M3 11L11 3M5 3h6v6" />
                    </svg>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
